import { Directionality } from "@angular/cdk/bidi";
import { Overlay, OverlayKeyboardDispatcher, OverlayOutsideClickDispatcher, OverlayPositionBuilder, ScrollStrategyOptions } from "@angular/cdk/overlay";
import { DOCUMENT } from "@angular/common";
import { ComponentFactoryResolver, Inject, Injectable, Injector, NgZone } from "@angular/core";
import { DynamicOverlayContainer } from "./dynamic-overlay-container";
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DynamicOverlay extends Overlay {
  private _dynamicOverlayContainer: DynamicOverlayContainer;

  constructor(scrollStrategies: ScrollStrategyOptions,
      _overlayContainer: DynamicOverlayContainer,
      _componentFactoryResolver: ComponentFactoryResolver,
      _positionBuilder: OverlayPositionBuilder,
      _keyboardDispatcher: OverlayKeyboardDispatcher,
      _injector: Injector,
      _ngZone: NgZone,
      @Inject(DOCUMENT) document: Document,
      _directionality: Directionality,
      _location: Location,
      _outsideClickDispatcher: OverlayOutsideClickDispatcher

  ) {
      super(scrollStrategies,
          _overlayContainer,
          _componentFactoryResolver,
          _positionBuilder,
          _keyboardDispatcher,
          _injector,
          _ngZone,
          document,
          _directionality,
          _location,
          _outsideClickDispatcher);

      this._dynamicOverlayContainer = _overlayContainer;
  }

  public setContainerElement(containerElement: HTMLElement): void {
      this._dynamicOverlayContainer.setContainerElement(containerElement);
  }
}